import { render, staticRenderFns } from "./question-builder.vue?vue&type=template&id=659ffa61&scoped=true"
import script from "./question-builder.vue?vue&type=script&lang=js"
export * from "./question-builder.vue?vue&type=script&lang=js"
import style0 from "./question-builder.vue?vue&type=style&index=0&id=659ffa61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659ffa61",
  null
  
)

export default component.exports